import GM_Helper from './gm-helper.js';

const backToTopBtn = document.getElementById('back-to-top');
const footer = document.querySelector('.footer');

if (backToTopBtn && footer) {
    let isScrolling = false;

    const checkScroll = () => {
        if (isScrolling) return;

        const footerTop = footer.getBoundingClientRect().top + window.pageYOffset;
        const scrollPosition = window.pageYOffset + window.innerHeight;
        const threshold = footerTop - 600;

        if (window.pageYOffset > 300 && scrollPosition > threshold) {
            if (backToTopBtn.getAttribute('aria-hidden') === 'true') {
                backToTopBtn.setAttribute('aria-hidden', 'false');
                backToTopBtn.setAttribute('tabindex', '0');
            }
        } else {
            if (backToTopBtn.getAttribute('aria-hidden') === 'false') {
                backToTopBtn.setAttribute('aria-hidden', 'true');
                backToTopBtn.setAttribute('tabindex', '-1');
            }
        }
    };

    window.addEventListener('scroll', checkScroll, { passive: true });

    backToTopBtn.addEventListener('click', () => {
        backToTopBtn.setAttribute('aria-hidden', 'true');
        backToTopBtn.setAttribute('tabindex', '-1');
        isScrolling = true;
        GM_Helper.smoothScrollTo(0, 1400, (completed) => {
            isScrolling = false;
            checkScroll();
        });
    });

    checkScroll();
}
